import {
  cities,
  countries
} from '@features/admin/components/location-details/cityMapping';

export type MemberAddressFilterOption = {
  id: string;
  label: string;
  value: string;
};

export const MEMBER_COUNTRY_FILTER_OPTIONS: MemberAddressFilterOption[] =
  countries
    .map((country) => ({
      id: country,
      label: country,
      value: country
    }))
    .concat({ id: 'Others', label: 'Others', value: 'Others' });

export const MEMBER_STATE_FILTER_OPTIONS: MemberAddressFilterOption[] =
  Object.keys(cities).map((state) => ({
    id: state,
    label: state,
    value: state
  }));
